import { render, staticRenderFns } from "./BulkWizardConfirm.vue?vue&type=template&id=560a587f&scoped=true&"
import script from "./BulkWizardConfirm.vue?vue&type=script&lang=js&"
export * from "./BulkWizardConfirm.vue?vue&type=script&lang=js&"
import style0 from "./BulkWizardConfirm.vue?vue&type=style&index=0&id=560a587f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560a587f",
  null
  
)

export default component.exports